import { createFileRoute, Outlet } from "@tanstack/react-router";
import {
  IncompleteUrlFallback,
  OrgProjectErrorFallback,
} from "@/lib/org-project-context/error-fallbacks";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects"
)({
  component: () => <Outlet />,
  errorComponent: OrgProjectErrorFallback,
  notFoundComponent: IncompleteUrlFallback,
});
